import { ResponsiveStringValue } from "@punks/ui-core"
import { responsiveClasses, responsiveCssVariables } from "./variables"

export const normalizeSpaceValue = (value: string | number | undefined) => {
  if (!value) return undefined

  if (typeof value === "number" || value.match(/^\d+$/)) {
    return `calc(${value} * var(--wp-theme-spacing-unit))`
  }
  return value
}

export const normalizeSpacing = (spacing: ResponsiveStringValue) => {
  return {
    ...(spacing?.xs
      ? {
          xs: normalizeSpaceValue(spacing.xs),
        }
      : {}),
    ...(spacing?.sm
      ? {
          sm: normalizeSpaceValue(spacing.sm),
        }
      : {}),
    ...(spacing?.md
      ? {
          md: normalizeSpaceValue(spacing.md),
        }
      : {}),
    ...(spacing?.lg
      ? {
          lg: normalizeSpaceValue(spacing.lg),
        }
      : {}),
    ...(spacing?.xl
      ? {
          xl: normalizeSpaceValue(spacing.xl),
        }
      : {}),
  }
}

export const responsivePaddings = (padding: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("p", normalizeSpacing(padding)),
    classes: responsiveClasses(
      {
        xs: "p-[var(--p)]",
        sm: "sm:p-[var(--p-sm)]",
        md: "md:p-[var(--p-md)]",
        lg: "lg:p-[var(--p-lg)]",
        xl: "xl:p-[var(--p-xl)]",
      },
      padding
    ),
  }
}

export const responsivePaddingX = (padding: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("px", normalizeSpacing(padding)),
    classes: responsiveClasses(
      {
        xs: "px-[var(--px)]",
        sm: "sm:px-[var(--px-sm)]",
        md: "md:px-[var(--px-md)]",
        lg: "lg:px-[var(--px-lg)]",
        xl: "xl:px-[var(--px-xl)]",
      },
      padding
    ),
  }
}

export const responsivePaddingY = (padding: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("py", normalizeSpacing(padding)),
    classes: responsiveClasses(
      {
        xs: "py-[var(--py)]",
        sm: "sm:py-[var(--py-sm)]",
        md: "md:py-[var(--py-md)]",
        lg: "lg:py-[var(--py-lg)]",
        xl: "xl:py-[var(--py-xl)]",
      },
      padding
    ),
  }
}

export const responsiveMargin = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("m", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "m-[var(--m)]",
        sm: "sm:m-[var(--m-sm)]",
        md: "md:m-[var(--m-md)]",
        lg: "lg:m-[var(--m-lg)]",
        xl: "xl:m-[var(--m-xl)]",
      },
      value
    ),
  }
}

export const responsiveMarginX = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("mx", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "mx-[var(--mx)]",
        sm: "sm:mx-[var(--mx-sm)]",
        md: "md:mx-[var(--mx-md)]",
        lg: "lg:mx-[var(--mx-lg)]",
        xl: "xl:mx-[var(--mx-xl)]",
      },
      value
    ),
  }
}

export const responsiveMarginY = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("my", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "my-[var(--my)]",
        sm: "sm:my-[var(--my-sm)]",
        md: "md:my-[var(--my-md)]",
        lg: "lg:my-[var(--my-lg)]",
        xl: "xl:my-[var(--my-xl)]",
      },
      value
    ),
  }
}

export const responsiveMarginT = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("mt", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "mt-[var(--mt)]",
        sm: "sm:mt-[var(--mt-sm)]",
        md: "md:mt-[var(--mt-md)]",
        lg: "lg:mt-[var(--mt-lg)]",
        xl: "xl:mt-[var(--mt-xl)]",
      },
      value
    ),
  }
}

export const responsiveMarginB = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("mb", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "mb-[var(--mb)]",
        sm: "sm:mb-[var(--mb-sm)]",
        md: "md:mb-[var(--mb-md)]",
        lg: "lg:mb-[var(--mb-lg)]",
        xl: "xl:mb-[var(--mb-xl)]",
      },
      value
    ),
  }
}

export const responsiveHeight = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("h", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "h-[var(--h)]",
        sm: "sm:h-[var(--h-sm)]",
        md: "md:h-[var(--h-md)]",
        lg: "lg:h-[var(--h-lg)]",
        xl: "xl:h-[var(--h-xl)]",
      },
      value
    ),
  }
}

export const responsiveMinHeight = (value: ResponsiveStringValue) => {
  return {
    styles: responsiveCssVariables("min-h", normalizeSpacing(value)),
    classes: responsiveClasses(
      {
        xs: "min-h-[var(--min-h)]",
        sm: "sm:min-h-[var(--min-h-sm)]",
        md: "md:min-h-[var(--min-h-md)]",
        lg: "lg:min-h-[var(--min-h-lg)]",
        xl: "xl:min-h-[var(--min-h-xl)]",
      },
      value
    ),
  }
}
